import { render, staticRenderFns } from "./AddBenefit.vue?vue&type=template&id=491af6a6&"
import script from "./AddBenefit.vue?vue&type=script&lang=js&"
export * from "./AddBenefit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports